import React, { useState, useRef, useEffect } from 'react'
import classes from '@src/styles/Sustainability.module.css'
import { MdAdd } from 'react-icons/md'
import Link from 'next/link'
import Head from 'next/head'

const getTransformStyle = (expanded: boolean) => (expanded ? 'rotate(45deg)' : '')

export const SustainabilityCard = ({
  item,
  index,
  expanded,
  handleOpen,
}: {
  item: any
  index: number
  expanded: boolean
  handleOpen: any
}) => (
  <div className={classes.feature}>
    <img alt='' src={item.jetpack_featured_media_url ?? ''} className={classes.imgIcon} />
    <div
      role='button'
      tabIndex={0}
      className={classes.customAccordion}
      onClick={() => handleOpen(`panel${index + 1}`)}
      onKeyDown={() => handleOpen(`panel${index + 1}`)}
    >
      <div className={classes.accordionSummary}>
        {/* <p className={classes.accordionHeader}>{ReactHtmlParser(item.title?.rendered)}</p> */}
      </div>
      <MdAdd className={classes.primaryButton} style={{ transform: getTransformStyle(expanded) }} />
      {expanded && (
        <div className={classes.accordionDetails}>
          {/* <span>{ReactHtmlParser(item.excerpt?.rendered)}</span> */}
          <Link className={classes.link} href={`/business/${item.slug}`}>
            Read more
          </Link>
        </div>
      )}
    </div>
  </div>
)

function Sustainability() {
  const [openAccordions, setOpenAccordions] = useState<Array<string>>([])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [posts, setPosts] = useState([])

  const handleOpen = (accordion: string) => {
    if (!openAccordions.includes(accordion)) {
      setOpenAccordions((state) => [...state, accordion])
    } else {
      setOpenAccordions((state) => state.filter((i) => i !== accordion))
    }
  }

  const subscribed = useRef(false)

  const getPost = async () => {
    // await getWordpressPostList('1372', setPosts, subscribed)
  }

  useEffect(() => {
    subscribed.current = true
    getPost()
    return () => {
      subscribed.current = false
    }
  }, [])

  return (
    <>
      <Head>
        <link rel="canonical" href="https://getdimension.com/sustainability" />
      </Head>
      <div className={classes.container}>
        <div className={classes.mainContent}>
          <div className={classes.hero}>
            <h2 className={classes.header}>
              Sustainable Waste Management Solutions for your Unique Business Needs.
            </h2>
            <p className={classes.description}>
              Every industry has their own waste problems, which is why we focus on providing
              customized, efficient, budget friendly and sustainable disposal solutions. Learn more
              about our industry-specific solutions and expertise.
            </p>
          </div>
          <div className={classes.resourceContainer}>
            {posts.map((post: any, index: number) => (
              <SustainabilityCard
                item={post}
                key={post.id}
                index={index}
                expanded={openAccordions.includes(`panel${index + 1}`)}
                handleOpen={handleOpen}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default Sustainability
